import { render } from "./Snackbar-Failed.vue?vue&type=template&id=6a111e6f"
import script from "./Snackbar-Failed.vue?vue&type=script&lang=js"
export * from "./Snackbar-Failed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__